module.exports = __webpack_public_path__ + "img/index-honor88.14211f54.png";